import { render, staticRenderFns } from "./StaticErrors.html?vue&type=template&id=31175368&scoped=true&"
import script from "./StaticErrors.ts?vue&type=script&lang=ts&"
export * from "./StaticErrors.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/checkout/_errors.scss?vue&type=style&index=0&id=31175368&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31175368",
  null
  
)

export default component.exports